import initScrollReveal from "./scripts/scrollReveal";
import initTiltEffect from "./scripts/tiltAnimation";
import { targetElements, defaultProps } from "./data/scrollRevealConfig";
import fullYear from "./fullYear";

initScrollReveal(targetElements, defaultProps);
initTiltEffect();
